import { __read } from "tslib";
import React, { useState, useEffect, createRef } from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import { throttle } from 'lodash';
var StickyHeader = function (props) {
    var showGoBack = props.showGoBack, goBack = props.goBack, title = props.title, onSticky = props.onSticky, onUnSticky = props.onUnSticky;
    var ref = createRef();
    var _a = __read(useState(false), 2), isSticky = _a[0], setSticky = _a[1];
    var top = window.innerWidth > 1000 ? 78 : 110;
    useEffect(function () {
        var container = document.getElementById('sticky-container');
        // Add scroll event when the component is loaded
        container && container.addEventListener('scroll', throttle(handleScroll, 100));
        return function () {
            // Remove scroll event after the component is unmount,
            // like componentWillUnmount()
            container && container.removeEventListener('scroll', function () { return handleScroll; });
        };
        // Here, we set useEffect() arguments as empty array.
        // This means useEffect() will only run once after component loaded
    });
    var handleScroll = function () {
        // Make sure ref has current attibute and getBoundingClientRect function
        // otherwise, it could cause getBoundingClientRect undefined error.
        if (ref && ref.current && ref.current.getBoundingClientRect()) {
            // Then, we compare the distance of the ref component to the top
            // with top value we set. If less than, we set isStick ture.
            if (onSticky && ref && ref.current && ref.current.getBoundingClientRect().top <= top) {
                if (!ref.current.classList.contains('is-sticky')) {
                    setSticky(true);
                    onSticky(title);
                }
            }
            else {
                if (ref.current.classList.contains('is-sticky') && onUnSticky) {
                    setSticky(false);
                    onUnSticky(title);
                }
            }
        }
    };
    return (React.createElement("h2", { className: "category-name sticky__wrapper ".concat(isSticky && 'is-sticky'), ref: ref },
        showGoBack && React.createElement("span", { className: "category-name__go-back", onClick: function () { return goBack; } },
            React.createElement(FaChevronLeft, null)),
        React.createElement("span", { className: "category-name__text" }, title)));
};
export default StickyHeader;
//# sourceMappingURL=StickyHeader.js.map